import { render, staticRenderFns } from "./SharedButton.vue?vue&type=template&id=1650506e&scoped=true&"
import script from "./SharedButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SharedButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SharedButton.vue?vue&type=style&index=0&id=1650506e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650506e",
  null
  
)

export default component.exports